
<div class="main-attribute">
    <div style="text-align: end;">
        <button class="button darkblue" (click)="newAttribute()">
            <i class="pi pi-plus"></i>
            <span i18n="@@New">New</span>
        </button>
    </div>
    <div class="card">
        <p-table #dt
                 [value]="listAttribute"
                 [paginator]="true"
                 [rows]="10"
                 [totalRecords]="totalAttribute"
                 [lazy]="true"
                 (onLazyLoad)="loadListAttribute(dt)"
                 [showCurrentPageReport]="true"
                 [tableStyle]="{ 'min-width': '50rem' }"
                 [currentPageReportTemplate]="farsitableTemplate(dt.first,totalAttribute)"

                 [paginatorLocale]="locale=='fa'?'fa-IR':''"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:25%" i18n="@@name">name</th>
                    <th style="width:25%"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-attr>
                <tr>
                    <td>{{ attr.name }}</td>
                    <td>
                        <div class="operation-icons">
                            <i class="pi pi-pencil" (click)="editAttribute(attr)"></i>
                            <i class="pi pi-trash" (click)="deleteAttribute(attr,dt)"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog i18n-header="@@Attribute" header="Attribute" [resizable]="false"
          [(visible)]="displayEdit"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'60vw'}">
    <div class="  lg:col-12">
        <div><label i18n="@@name">name</label> :</div>
        <input class="title-item" style="width: 100%;" [(ngModel)]="selectedAttribute.name">
    </div>
    <p-footer>
        <button class="button darkblue" (click)="savaAttribute(dt)">
            <span i18n="@@Save">Save</span>
        </button>
    </p-footer>
</p-dialog>